/**
 * @generated SignedSource<<6dda330d8966e8ab51b63b0263204299>>
 * @relayHash cc6e35fb990db7cbb822759a08f51cce
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b65896953c1233c97ea3a94bae2c96f584f836e4e148c3ec4385046c740df330

import type { ConcreteRequest } from 'relay-runtime';
export type HomeRecentAgentSessionAssociationsQuery$variables = {
  aqlQuery: string;
  first: number;
  shardingContext: string;
};
export type HomeRecentAgentSessionAssociationsQuery$data = {
  readonly agent_sessionAssociationQuery: {
    readonly nodes: ReadonlyArray<{
      readonly agentSession: {
        readonly id: string | null;
      } | null;
      readonly conversationId: string | null;
      readonly invocationType: string | null;
      readonly subEntityId: string | null;
    } | null> | null;
  } | null;
};
export type HomeRecentAgentSessionAssociationsQuery = {
  response: HomeRecentAgentSessionAssociationsQuery$data;
  variables: HomeRecentAgentSessionAssociationsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "aqlQuery"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shardingContext"
},
v3 = [
  {
    "kind": "Variable",
    "name": "aqlQuery",
    "variableName": "aqlQuery"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "shardingContext",
    "variableName": "shardingContext"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "conversationId"
},
v5 = {
  "kind": "ScalarField",
  "name": "invocationType"
},
v6 = {
  "kind": "ScalarField",
  "name": "subEntityId"
},
v7 = {
  "kind": "ScalarField",
  "name": "id"
},
v8 = {
  "concreteType": "AgentSession",
  "kind": "LinkedField",
  "name": "agentSession",
  "plural": false,
  "selections": [
    (v7/*: any*/)
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "HomeRecentAgentSessionAssociationsQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "AgentSessionAssociationConnection",
        "kind": "LinkedField",
        "name": "agent_sessionAssociationQuery",
        "plural": false,
        "selections": [
          {
            "concreteType": "AgentSessionAssociation",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v8/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "HomeRecentAgentSessionAssociationsQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "AgentSessionAssociationConnection",
        "kind": "LinkedField",
        "name": "agent_sessionAssociationQuery",
        "plural": false,
        "selections": [
          {
            "concreteType": "AgentSessionAssociation",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v8/*: any*/),
              (v7/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "cc6e35fb990db7cbb822759a08f51cce",
    "id": "b65896953c1233c97ea3a94bae2c96f584f836e4e148c3ec4385046c740df330",
    "metadata": {},
    "name": "HomeRecentAgentSessionAssociationsQuery",
    "operationKind": "query",
    "text": "query HomeRecentAgentSessionAssociationsQuery($aqlQuery:String!,$shardingContext:String!,$first:Int!){agent_sessionAssociationQuery(aqlQuery:$aqlQuery,shardingContext:$shardingContext,first:$first){nodes{conversationId,invocationType,subEntityId,agentSession{id},id}}}"
  }
};
})();

(node as any).hash = "3b039a916c2f6c4b0c17b1e027de3469";

export default node;
